import React from "react";

import {IconButton} from "@material-ui/core";
import LinkIcon from "@material-ui/icons/Link";
import FilterIcon from "@material-ui/icons/FilterList";
import ListLink from "../styled/ListLink";

interface FilterableNameProps {
  label?: string;
  name?: string | React.ReactNode;
  url?: string;
  filter?: () => void;
  children?: React.ReactNode;
}

function FilterableName({
  label,
  name,
  url,
  filter,
  children,
}: FilterableNameProps) {
  return (
    <div style={{backgroundColor: "inherit"}}>
      {label && (
        <div
          style={{
            textAlign: "left",
            fontStyle: "italic",
            fontSize: "0.75em",
            color: "#888",
          }}
        >
          {label}
        </div>
      )}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          position: "relative",
          backgroundColor: "inherit",
        }}
      >
        <div
          style={{
            textAlign: "left",
            overflow: "hidden",
            marginRight: "60px",
            wordBreak: "break-word",
          }}
        >
          {name || children}
        </div>
        <div
          style={{
            position: "absolute",
            right: "0",
            backgroundColor: "inherit",
            height: "100%",
            display: "flex",
            alignItems: "center",
          }}
        >
          {filter ? (
            <IconButton
              size="small"
              onClick={event => {
                filter();
                event.stopPropagation();
              }}
              style={{paddingTop: 0, paddingBottom: 0}}
            >
              <FilterIcon />
            </IconButton>
          ) : null}
          {url ? (
            <ListLink to={url}>
              <IconButton
                size="small"
                style={{paddingTop: 0, paddingBottom: 0}}
              >
                <LinkIcon />
              </IconButton>
            </ListLink>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default FilterableName;
